define(function (require) {

    var Modernizr = window.Modernizr || function () {
        };

    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');

    /*
     @param tableName
     @param defaultFilter - The default state of the filter (true/false/null) default: null
     @param left - Set the top arrow X px to the left
     @param right - Set the top arrow X px to the right (only if left is not set)
     */
    var BaseFilterViewController = ViewController.extend({
        ControllerName: 'BaseFilterViewController',
        // Need to be update by child

        LPViewMap: {
            filterArea: ".lpview_filterArea",
            reset_button: ".lpview_reset_button",
            filter_button: ".lpview_filter_button",
            cancel_button: ".lpview_topCancelButton",
            main_div: ".lpview_filterWindow",
            top_arrow: ".lpview_top_arrow",
            filter_reset: ".lpview_reset_button",
            list_item: "lpview_listitem_text"
        },
        LPClassesMap: {
            disabled: 'disabled'
        },

        initialize: function (constructorData) {
            this.defaultFilterIsActive = constructorData.defaultFilterIsActive || false;
            this.filterData = {};
            this.filterResetData = {};
            this.filterUIData = {};
            this.centerArrow = false;
            this.filterName = constructorData.filterName;
            this.tableName = constructorData.tableName;
            this.notifyFilterClosedCallback = constructorData.notifyFilterClosedCallback;
            this.isSetAndHideReset = (this.filterName === "historyDataFilter"); //TODO expand to a list somewhere?
            if (constructorData.iconCallback) {
                this.iconCallback = constructorData.iconCallback;
                this.iconContext = constructorData.iconContext;
                this.iconId = constructorData.iconId;
            }
            this.setTemplateAndCreateView();

            if (constructorData.left) {
                this.getFirstElement(this.LPViewMap.top_arrow).style.left = constructorData.left + "px";

            } else if (constructorData.right) {
                this.getFirstElement(this.LPViewMap.top_arrow).style.right = constructorData.right + "px";
            } else {
                this.centerArrow = true;
            }
        },

        events: function () {
            this.bindViewEvent({selector: this.LPViewMap.cancel_button, DOMEvent: "click", callback: this.cancel});
            if (!Modernizr.isedge) {
                this.bindViewEvent({
                    selector: this.LPViewMap.main_div,
                    DOMEvent: "blur",
                    callback: this.cancel,
                    ignoreChildBlur: true,
                    includeSelf: true
                });
            }
            this.bindViewEvent({selector: this.LPViewMap.reset_button, DOMEvent: "click", callback: this.reset});
            this.bindViewEvent({selector: this.LPViewMap.filter_button, DOMEvent: "click", callback: this.submitClick});
            this.viewEventsHandler.bindEvent({
                appName: this.tableName,
                UIEvent: this.eventType.TABLE_FILTER_OPENED,
                callback: this.handleFilterOpened
            });
            this.viewEventsHandler.bindEvent({
                appName: this.tableName,
                UIEvent: this.eventType.TABLE_WIDGETS_OPENED,
                callback: this.cancel
            });
        },

        render: function () {

        }
    });

// When cancel button clicked or if user click outside of the filter box
    BaseFilterViewController.prototype.cancel = function () {
        this.lpHide();
    };

    BaseFilterViewController.prototype.disableFilterButton = function () {
        this.addClass(this.LPViewMap.filter_button, this.LPClassesMap.disabled);
        this.unbindViewEvent({selector: this.LPViewMap.filter_button, DOMEvent: "click", callback: this.submitClick});
    };

    BaseFilterViewController.prototype.enableFilterButton = function () {
        this.removeClass(this.LPViewMap.filter_button, this.LPClassesMap.disabled);
        this.bindViewEvent({selector: this.LPViewMap.filter_button, DOMEvent: "click", callback: this.submitClick});
    };

    /**
     * Get the filter from the API result and update the filterData
     * @param searchData
     */
    BaseFilterViewController.prototype.setFilter = function (searchData) {
        if (typeof searchData !== 'undefined' && !this.isEmptyValue(searchData)) {
            this.filterData = lpUtils.cloneObject(searchData);
            this.isFilterd = true;
        }

        this.isFilterd = this.isFilterSet();

        if (this.iconCallback) {
            this.iconCallback.call(this.iconContext, this.iconId, this.isFilterd ? this.iconContext.LPIconStatus.on : this.iconContext.LPIconStatus.off);
        }
    };

//set up the template and create the view
    BaseFilterViewController.prototype.setTemplateAndCreateView = function () {
        var newTemplateFile;
        var textInjection;
        var currentTemplateFile = require('web-agent-templates/LP_base_filter_view.html');
        // var currentTemplateFile = lpUtils.loadResource('web-agent-templates/LP_base_filter_view.html');

        //prepare template file
        if (this.isSetAndHideReset) {
            textInjection = {
                filter_button_filter_text: this.translate("filter_button_set")
            };
        } else {
            textInjection = {
                filter_button_filter_text: this.translate("filter_button_filter")
            };
        }

        //set the template file and create view
        newTemplateFile = this.injectTextDefaults(currentTemplateFile, textInjection);
        this.createView({
            template: newTemplateFile
        });

        //hide the reset button if necessary
        if (this.isSetAndHideReset) {
            this.getFirstElement(this.LPViewMap.filter_reset).className += " hide";
        }
    };

    BaseFilterViewController.prototype.reset = function () {
        this.filterUIData = lpUtils.cloneObject(this.filterResetData);
        this.submitFilter(true);
    };

    BaseFilterViewController.prototype.updateFilterUI = function () {
        // need to be replace by the filter
    };

    BaseFilterViewController.prototype.onShow = function () {
        this.filterUIData = lpUtils.cloneObject(this.filterData);
        this.updateFilterUI();
    };
    /**
     * Checking if the filter is null or set for the filter icon status
     * @returns {boolean}
     */
    BaseFilterViewController.prototype.isFilterSet = function () {
        return this.defaultFilterIsActive ? (this.isDefaultFilterSet() || this.isFilterd) : this.isFilterd;
    };

    /**
     * check if the current filter is the default filter.
     */
    BaseFilterViewController.prototype.isDefaultFilterSet = function () {
        return this.isFiltersMatch(this.filterData, this.filterResetData);
    };

    BaseFilterViewController.prototype.isFiltersMatch = function (filter1, filter2) {
        return (JSON.stringify(filter1) === JSON.stringify(filter2));
    };

    BaseFilterViewController.prototype.submitClick = function () {
        this.submitFilter();
    };

    BaseFilterViewController.prototype.isEmptyValue = function (dataObj) {
        return typeof dataObj === 'undefined' || dataObj === null || dataObj === "";
    };


    BaseFilterViewController.prototype.submitFilter = function (isReset) {
        var eventData = {};
        // setting the flag for the filter set.
        var isResetOperation = !!isReset || this.isEmptyValue(this.filterUIData);
        this.filterData = isResetOperation ? lpUtils.cloneObject(this.filterResetData) : lpUtils.cloneObject(this.filterUIData);
        this.isFilterd = !isResetOperation;

        eventData[this.filterName] = isResetOperation ? undefined : this.filterData;
        eventData.startPage = 1;

        //set the event type to be fired
        var UIEventName = this.viewEventsHandler.eventType.TABLE_FILTERING_CHANGED;
        if (this.searchFilterEventCallback) {
            UIEventName = this.viewEventsHandler.eventType.TABLE_SEARCH_FILTER_CHANGED;
        }

        // sending the event of the filter.
        this.viewEventsHandler.fireEvent({
            appName: this.tableName,
            UIEvent: UIEventName,
            eventData: eventData
        });
        // Update the filter icon
        if (this.iconCallback) {
            this.iconCallback.call(this.iconContext, this.iconId, this.isFilterSet() ? this.iconContext.LPIconStatus.on : this.iconContext.LPIconStatus.off);
        }
        // hide the filter
        this.lpHide();
    };

    BaseFilterViewController.prototype.handleFilterOpened = function (data) {
        if (data && data.newValue && data.newValue.eventData && data.newValue.eventData.filterName) {
            if (data.newValue.eventData.filterName === this.filterName) {
                this.lpShow();
            } else {
                this.lpHide();
            }
        }
    };

// Show the filter and set focus for the blue event
// Don't use lpShow with out the focus!!!!!!!!
    BaseFilterViewController.prototype.lpShow = function (view, parentScope, animate) {
        if (!this.visible) {
            this.filterUIData = lpUtils.cloneObject(this.filterData);
            ViewController.prototype.lpShow.call(this, view, parentScope, animate);
            this.onShow();
            this.focus(this.LPViewMap.main_div);
            if (this.iconCallback) { // Show the filter icon
                this.iconCallback.call(this.iconContext, this.iconId, this.iconContext.LPIconStatus.show);
            }
        }
    };

    BaseFilterViewController.prototype.lpHide = function (view, parentScope, animate) {
        if (this.visible) {
            ViewController.prototype.lpHide.call(this, view, parentScope, animate);
            if (this.iconCallback) { // Hide the filter icon
                this.iconCallback.call(this.iconContext, this.iconId, this.iconContext.LPIconStatus.hide);
            }
            if (this.notifyFilterClosedCallback) {
                this.notifyFilterClosedCallback.call(this);
            }
        }
    };

    /**
     * Align filter position according to the filter icon and the table borders
     * @param {Object} parentView DOM view of the parent (TableHeader)
     * @param {Number} arrowLeftOffset desired offset for arrow
     */
    BaseFilterViewController.prototype.alignPosition = function (parentView, arrowLeftOffset) {
        var filterBoxInnerWidth = this.getComputedStyle(this.LPViewMap.main_div, "width", 10);
        var mainDivElement = this.getFirstElement(this.LPViewMap.main_div);
        var arrowElement = this.getFirstElement(this.LPViewMap.top_arrow);
        var filterLeftOffset = 0;

        //reset former adjustments
        mainDivElement.style.left = '';

        var parentRect = parentView.getBoundingClientRect();
        var filterRect = mainDivElement.getBoundingClientRect();

        if (filterRect.right > parentRect.right) {
            filterLeftOffset = parentRect.right - filterRect.right;
            mainDivElement.style.left = filterLeftOffset + "px";
        }

        if (arrowLeftOffset < filterBoxInnerWidth) {
            arrowElement.style.left = arrowLeftOffset + Math.abs(filterLeftOffset) + "px";
        } else {
            arrowElement.style.left = filterBoxInnerWidth + Math.abs(filterLeftOffset) + "px";
        }
    };

    BaseFilterViewController.prototype.setFocus = function () {
        this.focus(this.LPViewMap.main_div);
    };


    return BaseFilterViewController;

});
